import { createContext } from 'react';

export const LoggedInUserContext = createContext({});
